import { useTheme } from "../ThemeProvider";

/**
 * Panel flotante de resultados al buscar o filtrar expedientes.
 */
export default function ResultadosBusquedaExpediente({
  buscar,
  etiqueta,
  resultados,
  onAbrir,
  buscando = false,
  abierto = true,
  alinearDerecha = false,
}) {
  const { theme } = useTheme();
  const c = theme.colors;
  const isDark = theme.name === "dark";
  const tx = isDark ? "#ffffff" : c.textPrimary;
  const q = String(buscar || "").trim();
  if (!abierto || (!q && !etiqueta && !buscando)) return null;

  const titulo = buscando
    ? "Buscando…"
    : etiqueta || `${resultados.length} expediente(s) para «${q}»`;

  const panel = {
    width: "100%",
    minWidth: 280,
    maxHeight: "min(50vh, 320px)",
    overflow: "auto",
    borderRadius: 10,
    border: `1px solid ${isDark ? "#3d4a5c" : c.border}`,
    background: isDark ? "rgba(24, 28, 36, 0.96)" : "rgba(255, 255, 255, 0.97)",
    boxShadow: isDark ? "0 12px 40px rgba(0,0,0,0.45)" : "0 12px 32px rgba(0,0,0,0.14)",
    backdropFilter: "blur(8px)",
  };

  const fila = {
    display: "block",
    width: "100%",
    textAlign: "left",
    padding: "10px 14px",
    border: "none",
    borderBottom: `1px solid ${isDark ? "#2a3244" : c.borderLight}`,
    background: "transparent",
    color: tx,
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: 12,
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "calc(100% + 4px)",
        ...(alinearDerecha ? { right: 0 } : { left: 0 }),
        minWidth: 300,
        width: "max(100%, 300px)",
        zIndex: 50,
      }}
    >
      <div style={panel}>
        <div style={{ padding: "8px 14px", fontSize: 10, fontWeight: 700, color: isDark ? "#94a3b8" : c.textMuted, borderBottom: `1px solid ${isDark ? "#2a3244" : c.borderLight}` }}>
          {titulo}
        </div>
        {!buscando && resultados.length === 0 && (
          <div style={{ padding: "14px", fontSize: 12, color: isDark ? "#94a3b8" : c.textMuted }}>
            No hay expedientes que coincidan. Prueba con referencia, cliente, dirección o número.
          </div>
        )}
        {resultados.map((e, i) => {
          const sub = [e.cliente_nombre, e.resumen_propiedad].filter(Boolean).join(" · ");
          return (
            <button
              key={e.id}
              type="button"
              style={{ ...fila, borderBottom: i === resultados.length - 1 ? "none" : fila.borderBottom }}
              onClick={() => onAbrir(e.id)}
            >
              <div style={{ fontWeight: 800, fontSize: 13, marginBottom: sub ? 2 : 0 }}>{e.numero}</div>
              {sub && <div style={{ fontSize: 11, opacity: 0.85, lineHeight: 1.35 }}>{sub}</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
